<template lang="pug">
    include ../../icon/basic
    include ../../icon/color

    div(class="_infb inset-lg fixed-flex", :class="theme")
        div(class="fs4")
            template(v-if="theme == 'warning'")
                +icon-color-warning
            template(v-else-if="theme == 'positive'")
                +icon-basic-checkmark
            template(v-else-if="theme == 'negative'")
                +icon-basic-cancel
            template(v-else)
                +icon-basic-info
        div(class="insetx-lg")
            slot
</template>

<script>
    /**
     * A rectangular info box that displays a message and an icon based on the provided classname.
     */
    export default {
        name: 'ib-infobox',

        props: {
            /**
             * Theme (color and icon): ['positive, negative, warning, and accent']
             */
            theme: String
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._infb {
        background: fade(@bg-gray, 15%);
        border: 1px solid mix(@fg-gray, @bg, 35%);

        &.accent,
        &.primary {
            background: fade(@bg-accent, 15%);
            border-color: mix(@fg-accent, @bg, 35%);
        }
        &.positive {
            background: fade(@bg-positive, 15%);
            border-color: mix(@fg-positive, @bg, 35%);
        }
        &.negative {
            background: fade(@bg-negative, 15%);
            border-color: mix(@fg-negative, @bg, 35%);
        }
        &.warning {
            background: fade(@bg-warning, 15%);
            border-color: mix(@fg-warning, @bg, 35%);
            color: @fg !important;
        }
    }

    /** Traditional Chinese positive/negative colors */
    ._trcc ._infb {
        &.positive {
            background: fade(@bg-positive-trcc, 15%);
            border-color: mix(@fg-positive-trcc, @bg, 35%);
        }
        &.negative {
            background: fade(@bg-negative-trcc, 15%);
            border-color: mix(@fg-negative-trcc, @bg, 35%);
        }
    }
</style>

<docs>
    Basic Example:
    ```jsx
        <ib-context>
            <ib-infobox theme="accent" class="after-lg">
                <p>Hello, world.</p>
            </ib-infobox>
            <ib-infobox theme="negative" class="after-lg">
                <p>You're the worst!</p>
            </ib-infobox>
            <ib-infobox theme="positive" class="after-lg">
                <p>You're the best!</p>
            </ib-infobox>
            <ib-infobox theme="warning" class="after-lg">
                <p>Warning text</p>
            </ib-infobox>
            <ib-infobox class="after-lg">
                <p>Just a gray box</p>
            </ib-infobox>
        </ib-context>
    ```
</docs>
